import { render } from "./SesionErr.vue?vue&type=template&id=47280cb5"
import script from "./SesionErr.vue?vue&type=script&lang=js"
export * from "./SesionErr.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__